// IMPORT PACKAGE REFERENCES
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import 'firebase/storage';
import firebase from 'firebase/app';

//COMPONENT

class StickerItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            dropdownOpen: false,
            previewURL: '',
        };

        this.toggleDropDown = this.toggleDropDown.bind(this);
        this.deleteProduct = this.deleteProduct.bind(this);
        this.pushToStickerDetails = this.pushToStickerDetails.bind(this);
        this.showimage = this.showimage.bind(this);
        this._isMounted = false;
    }


    componentDidMount(){
        this._isMounted = true;
        this._isMounted && this.showimage();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    toggleDropDown() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    deleteProduct(){
        this.props.deleteItem(this.props.sticker.id);
    }

    pushToStickerDetails(){
        this.props.history.push('/stickers/' + this.props.sticker.id);
    }

    showimage() {
        firebase.storage().ref().child('preview-images/' + this.props.sticker['preview-image']).getDownloadURL().then(function(url) {
            this._isMounted && this.setState({previewURL: url});
        }.bind(this)).catch(function(error) {
            console.log(error);
        });
    }

    render() {
        return (
            <div className={'sticker-item float'}>

                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                    <div className='sticker-more'> 
                        <DropdownToggle className="hidden-dropdown" >
                        </DropdownToggle>
                        <img className='sticker-more-image noselect' src={require('../../../images/dotdotdot.png')} />
                    </div>

                    <DropdownMenu>
                        <DropdownItem header>Edit</DropdownItem>
                        <DropdownItem divider/>
                        <DropdownItem onClick={this.deleteProduct}>Delete</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
                
                <div className='sticker-details' onClick={this.pushToStickerDetails} >
                    <div >
                        <img className='segment-image noselect' src={this.state.previewURL == '' ? require('../../../images/empty-preview.png') : this.state.previewURL} />
                        <div className='sticker-title'> {this.props.sticker.name} </div>
                    </div>
                </div>
                
            </div>
        );
    }
}

StickerItem.propTypes = {
    history: PropTypes.object.isRequired,
    sticker: PropTypes.object.isRequired,
    deleteItem: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
};

const hoc = withRouter(StickerItem);

// EXPORT COMPONENT
export { hoc as StickerItem };


// WEBPACK FOOTER //
// ./src/components/pages/Stickers/StickerItem.js